module.exports = __webpack_public_path__ + "static/media/deck-grid-1.b32ff135.webp";